import { bindQueryParams } from "src/helpers/tools";
import { methods, request } from "./base";

const patientApis = {
  getPatientList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/patient_members_list",
      payload: data,
    }),
  addPatient: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/tests/update_patient_members",
      payload: data,
    }),
  deleteRecord: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/delete_patient_record",
      payload: data,
    }),
  addPatientPlan: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient_plans/add_patient_plan",
      payload: data,
    }),
  getQueryList: (payload: { queryType: string }) => {
    const route = bindQueryParams("/patient/query_list", payload);
    return request({
      route,
      method: methods.GET,
      priv: true,
      encrypt: true,
    });
  },
  sendQuery: (payload: {
    description: string;
    query_reason_master_id: string;
  }) =>
    request({
      route: "/patient/send_query",
      method: methods.POST,
      priv: true,
      encrypt: true,
      payload,
    }),
};

export default patientApis;
